var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    group = _require$doc$builders.group,
    indent = _require$doc$builders.indent,
    join = _require$doc$builders.join,
    line = _require$doc$builders.line,
    softline = _require$doc$builders.softline;

var parameterTypes = function parameterTypes(node, path, print) {
  return group(concat([indent(concat([softline, join(concat([',', line]), path.map(print, 'parameterTypes'))])), softline]));
};

var returnTypes = function returnTypes(node, path, print) {
  if (node.returnTypes.length > 0) {
    return concat([line, 'returns (', join(', ', path.map(print, 'returnTypes')), ')']);
  }

  return '';
};

var visibility = function visibility(node) {
  if (node.visibility && node.visibility !== 'default') {
    return concat([line, node.visibility]);
  }

  return '';
};

var stateMutability = function stateMutability(node) {
  if (node.stateMutability && node.stateMutability !== 'default') {
    return concat([line, node.stateMutability]);
  }

  return '';
};

var FunctionTypeName = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    return concat(['function(', parameterTypes(node, path, _print), ')', indent(group(concat([returnTypes(node, path, _print), visibility(node), stateMutability(node)])))]);
  }
};
module.exports = FunctionTypeName;